import axios from "axios";
import { useDispatch } from 'react-redux';
import { loginSuccess, logoutSuccess } from '../store/AuthSlice';
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const login = (email, password) => async (dispatch) => {
  try {
    const response = await axios.post(`${BASE_URL}/backend/user/login`, { email, password }, { withCredentials: true });

    if (response.data.user) {
      dispatch(loginSuccess({
        user: response.data.user,
        accessToken: response.data.tokens.access.token,
        refreshToken: response.data.tokens.refresh.token,
      }));
      return response.data.tokens.access.token;
    }
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};

export const logOut = () => async (dispatch, getState) => {
  try {
    const { refreshToken } = getState().auth;

    await axios.post(`${BASE_URL}/backend/user/logout`, { refreshToken }, {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    });

    dispatch(logoutSuccess());
  } catch (error) {
    console.error('Logout failed:', error);
    throw error;
  }
};


export const register = async (userData) => {
  try {
    const response = await fetch(`${BASE_URL}/backend/user/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      throw new Error("Registration failed");
    }
  } catch (error) {
    console.error("Registration failed:", error);
    throw error;
  }
};

// export const logOut = async () => {
//     try {
//         const response = await fetch(`${BASE_URL}/backend/user/logout`, {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: { },
//         });
//         localStorage.removeItem('user');
//         localStorage.removeItem('accessToken');

//     } catch (error) {
//         console.error("Logout failed:", error);
//         throw error;
//     }
// };

export const forgotPassword = async (email) => {
  try {

    const response = await axios.post(`${BASE_URL}/backend/user/forgot-password`, { email: email })

    if (response.data.success === true) {

      return response.data.success;
    } else {
      const errorData = response.data;

      throw new Error(errorData.message || 'Something went wrong. Please try again!');

    }
  } catch (error) {

    throw error;
  }
};

export const resetPassword = async (password, token) => {
  try {

    const response = await axios.post(`${BASE_URL}/backend/user/reset-password`, { password: password, token: token })

    if (response.data.success === true) {

      return response.data.success;
    } else {
      const errorData = response.data;

      throw new Error(errorData.message || 'Something went wrong. Please try again!');

    }
  } catch (error) {

    throw error;
  }
};
